module.exports = __webpack_public_path__ + "static/media/2020.4.14卫健委联合执法.03f13363.jpg";